import {DialogManager} from '@modifi/plugin-dialogs'

import InternalNoteDialog, {DIALOG_NAME as INTERNAL_NOTE_DIALOG} from './internal-note'
import ResolveTaskDialog, {DIALOG_NAME as RESOLVE_TASK_DIALOG} from './resolve-task'

DialogManager.addDialog(INTERNAL_NOTE_DIALOG, InternalNoteDialog, {
  layoutProps: {
    size: {
      col: 12,
      md: 6,
      lg: 7,
    },
  },
})

DialogManager.addDialog(RESOLVE_TASK_DIALOG, ResolveTaskDialog, {
  layoutProps: {
    size: {
      col: 12,
      md: 6,
      lg: 7,
    },
  },
})

export {INTERNAL_NOTE_DIALOG, RESOLVE_TASK_DIALOG}
